module.exports = __webpack_public_path__ + "static/media/LL_9789065449054.7ea892c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/LL_9789065449054.jpg
// module id = 1360
// module chunks = 1